<template>
  <v-container fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="5">
        <v-card elevation="8" class="pa-8">
          <div class="text-center">
            <v-avatar color="error" size="80" class="mb-4">
              <v-icon size="50" color="white">mdi-alert-circle</v-icon>
            </v-avatar>
            
            <h2 class="text-h4 font-weight-bold mb-2">Erro na Conexão</h2>
            <p class="text-body-1 grey--text mb-4">
              Não foi possível conectar ao Jira.
            </p>

            <v-alert
              v-if="errorMessage"
              type="error"
              outlined
              dense
              text
              class="mb-4"
            >
              <strong>Detalhes:</strong> {{ errorMessage }}
            </v-alert>

            <v-alert
              type="info"
              outlined
              dense
              text
              class="mb-4"
            >
              <strong>Possíveis causas:</strong>
              <ul class="text-left mt-2">
                <li>Credenciais OAuth inválidas</li>
                <li>Redirect URI não configurado corretamente</li>
                <li>Código de autorização expirado</li>
              </ul>
            </v-alert>

            <v-btn
              color="primary"
              large
              rounded
              class="mr-2"
              @click="tentarNovamente"
            >
              <v-icon left>mdi-refresh</v-icon>
              Tentar Novamente
            </v-btn>

            <v-btn
              color="grey"
              large
              rounded
              outlined
              @click="fecharJanela"
            >
              Fechar
            </v-btn>

            <p class="text-caption grey--text mt-4">
              Esta janela fechará automaticamente em {{ countdown }}s
            </p>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'JiraError',

  data: () => ({
    countdown: 10,
    intervalId: null,
    errorMessage: '',
  }),

  mounted() {
    // Pegar mensagem de erro da URL
    this.errorMessage = this.$route.query.error || 'Erro desconhecido'
    
    console.error('❌ Jira OAuth Error:', this.errorMessage)
    
    // Countdown para fechar automaticamente
    this.intervalId = setInterval(() => {
      this.countdown--
      if (this.countdown === 0) {
        this.fecharJanela()
      }
    }, 1000)
  },

  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },

  methods: {
    tentarNovamente() {
      if (window.opener) {
        // Recarregar página principal para tentar novamente
        window.opener.location.reload()
        window.close()
      } else {
        this.$router.push('/admin-settings')
      }
    },

    fecharJanela() {
      if (window.opener) {
        console.log('🔄 Fechando popup OAuth...')
        window.close()
      } else {
        console.log('↩️ Redirecionando para configurações...')
        this.$router.push('/admin-settings')
      }
    },
  },
}
</script>

<style scoped>
.fill-height {
  min-height: 100vh;
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}
</style>
